export default (type: string | undefined) => {
    switch (type) {
    case 'error':
        return { style: { backgroundColor: 'rgba(183, 152, 148, 0.85)' } };
    default:
        return undefined;
    }
};
